/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { AwardScoringCriteriaSettings, RegisteredContestantAwardRelationshipBaseModel } from './data-contracts';
import { ContentType, HttpClient, RequestParams } from './http-client';

export class RegisteredContestantAwardRelationship<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags RegisteredContestantAwardRelationship
   * @name GetAllAwardRelationshipRecordsByPageantId
   * @request GET:/RegisteredContestantAwardRelationship/GetAllAwardRelationshipRecordsByPageantId/Pageant:{pageantId}
   */
  getAllAwardRelationshipRecordsByPageantId = (pageantId: number, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/RegisteredContestantAwardRelationship/GetAllAwardRelationshipRecordsByPageantId/Pageant:${pageantId}`,
      method: 'GET',
      ...params,
    });
  /**
   * No description
   *
   * @tags RegisteredContestantAwardRelationship
   * @name UpdateAwardScoreUpdate
   * @request PUT:/RegisteredContestantAwardRelationship/UpdateAwardScore
   */
  updateAwardScoreUpdate = (
    query?: {
      /** @format int32 */
      contestantId?: number;
      /** @format int32 */
      titleId?: number;
      /** @format double */
      score?: number;
    },
    params: RequestParams = {}
  ) =>
    this.request<void, any>({
      path: `/RegisteredContestantAwardRelationship/UpdateAwardScore`,
      method: 'PUT',
      query: query,
      ...params,
    });
  /**
   * No description
   *
   * @tags RegisteredContestantAwardRelationship
   * @name UpdateIsContestantEnteredUpdate
   * @request PUT:/RegisteredContestantAwardRelationship/UpdateIsContestantEntered
   */
  updateIsContestantEnteredUpdate = (
    query?: {
      /** @format int32 */
      contestantId?: number;
      /** @format int32 */
      titleId?: number;
      isEntered?: boolean;
    },
    params: RequestParams = {}
  ) =>
    this.request<void, any>({
      path: `/RegisteredContestantAwardRelationship/UpdateIsContestantEntered`,
      method: 'PUT',
      query: query,
      ...params,
    });
  /**
   * No description
   *
   * @tags RegisteredContestantAwardRelationship
   * @name UpdateIsContestantEnteredDynamicallyUpdate
   * @request PUT:/RegisteredContestantAwardRelationship/UpdateIsContestantEnteredDynamically
   */
  updateIsContestantEnteredDynamicallyUpdate = (
    query?: {
      /** @format int32 */
      registeredContestantId?: number;
      /** @format int32 */
      titleId?: number;
    },
    params: RequestParams = {}
  ) =>
    this.request<void, any>({
      path: `/RegisteredContestantAwardRelationship/UpdateIsContestantEnteredDynamically`,
      method: 'PUT',
      query: query,
      ...params,
    });
  /**
   * No description
   *
   * @tags RegisteredContestantAwardRelationship
   * @name GetContestantCriteriaAttributesByPageantIdNewList
   * @request GET:/RegisteredContestantAwardRelationship/GetContestantCriteriaAttributesByPageantIdNew
   */
  getContestantCriteriaAttributesByPageantIdNewList = (
    query?: {
      /** @format int32 */
      pageantId?: number;
    },
    params: RequestParams = {}
  ) =>
    this.request<void, any>({
      path: `/RegisteredContestantAwardRelationship/GetContestantCriteriaAttributesByPageantIdNew`,
      method: 'GET',
      query: query,
      ...params,
    });
  /**
   * No description
   *
   * @tags RegisteredContestantAwardRelationship
   * @name ConfirmWinnerUpdate
   * @request PUT:/RegisteredContestantAwardRelationship/ConfirmWinner/{id}
   */
  confirmWinnerUpdate = (id: number, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/RegisteredContestantAwardRelationship/ConfirmWinner/${id}`,
      method: 'PUT',
      ...params,
    });
  /**
   * No description
   *
   * @tags RegisteredContestantAwardRelationship
   * @name RemoveWinnerDelete
   * @request DELETE:/RegisteredContestantAwardRelationship/RemoveWinner/{id}
   */
  removeWinnerDelete = (id: number, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/RegisteredContestantAwardRelationship/RemoveWinner/${id}`,
      method: 'DELETE',
      ...params,
    });
  /**
   * No description
   *
   * @tags RegisteredContestantAwardRelationship
   * @name CreateContestantAwardRelationshipCreate
   * @request POST:/RegisteredContestantAwardRelationship/CreateContestantAwardRelationship
   */
  createContestantAwardRelationshipCreate = (data: RegisteredContestantAwardRelationshipBaseModel, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/RegisteredContestantAwardRelationship/CreateContestantAwardRelationship`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags RegisteredContestantAwardRelationship
   * @name DeleteContestantAwardRelationshipDelete
   * @request DELETE:/RegisteredContestantAwardRelationship/DeleteContestantAwardRelationship/{id}
   */
  deleteContestantAwardRelationshipDelete = (id: number, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/RegisteredContestantAwardRelationship/DeleteContestantAwardRelationship/${id}`,
      method: 'DELETE',
      ...params,
    });
  /**
   * No description
   *
   * @tags RegisteredContestantAwardRelationship
   * @name UpdateContestantAwardRelationshipUpdate
   * @request PUT:/RegisteredContestantAwardRelationship/UpdateContestantAwardRelationship
   */
  updateContestantAwardRelationshipUpdate = (data: RegisteredContestantAwardRelationshipBaseModel[], params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/RegisteredContestantAwardRelationship/UpdateContestantAwardRelationship`,
      method: 'PUT',
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags RegisteredContestantAwardRelationship
   * @name DetermineWinnersCreate
   * @request POST:/RegisteredContestantAwardRelationship/{pageantId}/determine-winners
   */
  determineWinnersCreate = (pageantId: number, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/RegisteredContestantAwardRelationship/${pageantId}/determine-winners`,
      method: 'POST',
      ...params,
    });
  /**
   * No description
   *
   * @tags RegisteredContestantAwardRelationship
   * @name GetAwardScoreCriteria
   * @request POST:/RegisteredContestantAwardRelationship/GetAwardScoreCriteria/{titleId}
   */
  getAwardScoreCriteria = (titleId: number, data: AwardScoringCriteriaSettings, params: RequestParams = {}) =>
    this.request<AwardScoringCriteriaSettings, any>({
      path: `/RegisteredContestantAwardRelationship/GetAwardScoreCriteria/${titleId}`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
}
